import React from 'react';
import './About.css';


const About = () => {
  return (
    <section className="about" id="about">

      {/* HEADING */}
      <div className="about-label">
        <span className="label-line"></span>
        <span className="label-text">About <span>Me</span></span>
        <span className="label-line"></span>
      </div>

      {/* TOP GRID */}
      <div className="about-grid">

        {/* LEFT — BIO */}
        <div className="about-bio">
          <h2 className="about-heading">
            Creative <span>Designer</span><br />& Visual Thinker
          </h2>
          <p className="about-description">
            Creative and detail-oriented Graphic Designer with over one year of
            experience delivering impactful visual solutions. Proficient in developing
            engaging digital and print designs that strengthen brand identity and
            enhance audience engagement. Adept at combining creative vision with
            strategic thinking to produce visually compelling design outcomes.
          </p>
          <div className="about-stats">
            <div className="stat">
              <span className="stat-number">1+</span>
              <span className="stat-label">Years Experience</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <span className="stat-number">50+</span>
              <span className="stat-label">Projects Done</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <span className="stat-number">8</span>
              <span className="stat-label">Tools Mastered</span>
            </div>
          </div>
        </div>
<div className="device-wrapper" data-aos="fade-left">
  <img 
    src="/mockup.png" 
    alt="portfolio mockup"
    className="device-image"
  />
</div>

</div>
{/* SKILLS ROW */}
      <div className="skills-section" id="skills">
        <div className="skills-title-wrap">
          <div className="skills-title-bg">SKILLS</div>
          <div className="skills-title-front">
            <span className="skills-title-line"></span>
            <h2 className="skills-title-text">Professional <span>Skills</span></h2>
            <span className="skills-title-line"></span>
          </div>
        </div>

        <div className="skills-box-grid">
          {[
            {
              name: 'Graphic Design',
              desc: 'Creating impactful visual designs that communicate your brand message clearly and effectively.'
            },
            {
              name: 'Typography',
              desc: 'Mastery of fonts, spacing and layout to create beautiful and readable design compositions.'
            },
            {
              name: 'Video & Photo Editing',
              desc: 'Professional editing of photos and videos to enhance quality and visual storytelling.'
            },
            {
              name: 'Branding & Identity',
              desc: 'Building complete brand identities with logos, color palettes and brand guidelines.'
            },
            {
              name: 'Communication',
              desc: 'Strong client communication to deliver tailored design solutions that meet expectations.'
            },
            {
              name: 'Visual Thinking',
              desc: 'Creative problem solving through strategic visual concepts and innovative design ideas.'
            },
          ].map((skill, i) => (
            <div className="skills-box-card" key={i}>
              <div className="skills-box-number">
                {String(i + 1).padStart(2, '0')}
              </div>
              <h3 className="skills-box-name">{skill.name}</h3>
              <div className="skills-box-divider"></div>
              <p className="skills-box-desc">{skill.desc}</p>
              <div className="skills-box-arrow">→</div>
            </div>
          ))}
        </div>
      </div>

      {/* SOFTWARE ROW */}
      <div className="software-section">
        <div className="skills-title-wrap">
          <div className="skills-title-bg">TOOLS</div>
          <div className="skills-title-front">
            <span className="skills-title-line"></span>
            <h2 className="skills-title-text">Software <span>& Tools</span></h2>
            <span className="skills-title-line"></span>
          </div>
        </div>
        <div className="tools-showcase">
          {[
            { name: 'Canva', desc: 'Social Media & Branding', color: '#00C4CC', bg: '#00C4CC15', letter: 'Ca' },
            { name: 'Photoshop', desc: 'Photo Editing', color: '#31A8FF', bg: '#31A8FF15', letter: 'Ps' },
            { name: 'Illustrator', desc: 'Vector & Logo Design', color: '#FF9A00', bg: '#FF9A0015', letter: 'Ai' },
            { name: 'Lightroom', desc: 'Photo Enhancement', color: '#4FCCFF', bg: '#4FCCFF15', letter: 'Lr' },
            { name: 'Premiere Pro', desc: 'Video Editing', color: '#9999FF', bg: '#9999FF15', letter: 'Pr' },
            { name: 'Figma', desc: 'UI/UX Design', color: '#A259FF', bg: '#A259FF15', letter: 'Fi' },
            { name: 'CapCut', desc: 'Video Editing & Reels', color: '#ffffff', bg: '#ffffff10', letter: 'Cc' },
            { name: 'CorelDraw', desc: 'Print & Vector Design', color: '#00A550', bg: '#00A55015', letter: 'Cd' },
          ].map((tool, i) => (
            <div className="tool-showcase-card" key={i}
              style={{ '--tool-color': tool.color, '--tool-bg': tool.bg }}>
              <div className="tool-showcase-icon">
                <span className="tool-letter" style={{ color: tool.color }}>
                  {tool.letter}
                </span>
              </div>
              <div className="tool-showcase-glow"></div>
              <div className="tool-showcase-info">
                <span className="tool-showcase-name">{tool.name}</span>
                <span className="tool-showcase-desc">{tool.desc}</span>
              </div>
              <div className="tool-showcase-number">
                {String(i + 1).padStart(2, '0')}
              </div>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
};

export default About;